export const getBasePADUrl = ({ communityId }: { communityId: number }) =>
  `/admin/${communityId}`;
